import {IconButton} from "@mui/material";
import {RotateLeft, RotateRight, ZoomIn, ZoomOut} from "@mui/icons-material";
import React, {useEffect, useState} from "react";
import {Document, Page, pdfjs} from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
interface IPdfRendererProps {
	presignedUrl: string;
}

export const PdfRenderer: React.FC<IPdfRendererProps> = ({presignedUrl}) => {
	
	const [file, setFile] = useState<File | null>(null);
	const [zoom, setZoom] = useState(1.5);
	const [rotate, setRotate] = useState(0);
	const [maxPages, setMaxPages] = useState(1);
	
	useEffect(() => {
		fetch(presignedUrl)
			.then((response) => response.blob())
			.then((blob) => {
				const file = new File([blob], "document.pdf", {
					type: "application/pdf",
				});
				setFile(file);
			})
			.catch(console.error);
	}, [presignedUrl]);
	
	useEffect(() => {
		if (file) {
			file.arrayBuffer().then((arrayBuffer) => {
				pdfjs.getDocument(arrayBuffer).promise.then((doc) => {
					setMaxPages(doc.numPages);
				});
			});
		}
	}, [file]);
	
	// noinspection RequiredAttributes
	return (
		<div
			style={{
				maxHeight: "100%",
				height: "100%",
				width: "100%",
			}}
		>
			
			<div
				style={{
					position: "relative",
					zIndex: 2,
					left: "50%",
					bottom: "0",
					transform: "translateX(-50%)",
					textAlign: "center",
					backgroundColor: "#e3e3e3",
					padding: "5px",
					display: "flex",
				}}
			>
				<IconButton onClick={() => setZoom(zoom + 0.2)}>
					<ZoomIn/>
				</IconButton>
				<IconButton onClick={() => setZoom(zoom - 0.2)}>
					<ZoomOut/>
				</IconButton>
				<IconButton onClick={() => setRotate(rotate > 0 ? rotate-90 : 270)}>
					<RotateLeft/>
				</IconButton>
				<IconButton onClick={() => setRotate(rotate < 270 ? rotate+90 : 0)}>
					<RotateRight/>
				</IconButton>
			</div>
			
			<div
				style={{
					maxHeight: "100%",
					height: "100%",
					width: "100%",
					position: "relative",
					overflow: "scroll",
				}}
			>
				<Document file={file}>
					{Array(maxPages).fill(1).map((_el, i) =>
						<Page rotate={rotate} key={i} pageNumber={i + 1} scale={zoom} renderAnnotationLayer={false}
							renderTextLayer={true}/>
					)}
				</Document>
			</div>
		</div>
	);
};

